/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var processInclude = __webpack_require__(3);

	$(document).ready(function () {
	    processInclude(__webpack_require__(153));
	});

	function initSlickCarousel($carouselCointainer) {
	    var hideArrows = $carouselCointainer.parents('.recommendations.cc-recommendations-lh').data('hide-arrows');
	    var carouselSettings = {
	        infinite: true,
	        lazyLoad: 'ondemand',
	        slidesToScroll: 1,
	        slidesToShow: 4,
	        dots: false,
	        prevArrow: '<button type="button" class="cc-recommendations-arrows arrows-left slick-arrow"></button>',
	        nextArrow: '<button type="button" class="cc-recommendations-arrows arrows-right slick-arrow"></button>',
	        responsive: [{
	            breakpoint: 1200,
	            settings: {
	                slidesToScroll: 1,
	                slidesToShow: 3
	            }
	        }, {
	            breakpoint: 768,
	            settings: {
	                infinite: false,
	                slidesToScroll: 1,
	                slidesToShow: 2.32
	            }
	        }, {
	            breakpoint: 767,
	            settings: 'unslick'
	        }]
	    };

	    if (hideArrows) {
	        carouselSettings.responsive[1].settings.prevArrow = '';
	        carouselSettings.responsive[1].settings.nextArrow = '';
	    }

	    // trigger analytics event to track product views
	    $carouselCointainer.on('init', function (event, slick) {
	        $('body').trigger('analytics:recommendationsLoaded', slick.$slider.closest('.recommendations'));
	    });

	    // add .unslicked css class when carousel is unslicked (for example on mobile phones by its settings)
	    $carouselCointainer.on('destroy', function (event, slick) {
	        if (slick && slick.unslicked) {
	            slick.$slider.addClass('unslicked');
	        }
	    });

	    $carouselCointainer.slick(carouselSettings);
	}

	$('body').on('einsteinCarousel:setup', function (e, $carouselCointainer) {
	    if ($carouselCointainer) {
	        //Einstein page designer
	        var $carousel = $($carouselCointainer).find('.multiple-items');
	        if (!$carousel.hasClass('slick-initialized')) {
	            initSlickCarousel($carousel);
	        }
	    } else {
	        //Einstien content slots
	        initSlickCarousel($('.multiple-items.js-einstein-slot').not('.slick-initialized'));
	    }
	});

	$(function () {
	    //check if is the page designer's manual carousel
	    var $slides = $('.experience-slides');
	    var $experience = $('.experience-component.experience-commerce_carousel_product-carouselProductTile');

	    if ($experience.length > 0) {
	        $experience.each(function () {
	            if ($(this).children().length === 0) {
	                $(this).remove();
	            }
	        });
	    }

	    if ($slides.length > 0) {
	        $slides.each(function () {
	            $(this).addClass("multiple-items");
	        });
	    }
	    //select all the carousels that are not Einstein's ones
	    var $carousel = $('.multiple-items:not(.js-einstein-inner)').not('.slick-initialized');
	    $carousel.each(function () {
	        initSlickCarousel($(this));
	    });
	});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	module.exports = function (include) {
	    if (typeof include === 'function') {
	        include();
	    } else if ((typeof include === 'undefined' ? 'undefined' : _typeof(include)) === 'object') {
	        Object.keys(include).forEach(function (key) {
	            if (typeof include[key] === 'function') {
	                include[key]();
	            }
	        });
	    }
	};

/***/ }),

/***/ 104:
/***/ (function(module, exports) {

	"use strict";

	module.exports = function (module) {
		if (!module.webpackPolyfill) {
			module.deprecate = function () {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	};

/***/ }),

/***/ 120:
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	    setTabNextFocus: function setTabNextFocus(focusParams) {
	        var KEYCODE_TAB = 9;
	        var isTabPressed = focusParams.event.key === 'Tab' || focusParams.event.keyCode === KEYCODE_TAB;

	        if (!isTabPressed) {
	            return;
	        }

	        var firstFocusableEl = $(focusParams.containerSelector + ' ' + focusParams.firstElementSelector);
	        var lastFocusableEl = $(focusParams.containerSelector + ' ' + focusParams.lastElementSelector);

	        if ($(focusParams.containerSelector + ' ' + focusParams.lastElementSelector).is(':disabled')) {
	            lastFocusableEl = $(focusParams.containerSelector + ' ' + focusParams.nextToLastElementSelector);
	            if ($('.product-quickview.product-set').length > 0) {
	                var linkElements = $(focusParams.containerSelector + ' a#fa-link.share-icons');
	                lastFocusableEl = linkElements[linkElements.length - 1];
	            }
	        }

	        if (focusParams.event.shiftKey) /* shift + tab */{
	                if ($(':focus').is(firstFocusableEl)) {
	                    lastFocusableEl.focus();
	                    focusParams.event.preventDefault();
	                }
	            } else /* tab */{
	                if ($(':focus').is(lastFocusableEl)) {
	                    // eslint-disable-line
	                    firstFocusableEl.focus();
	                    focusParams.event.preventDefault();
	                }
	            }
	    }
	};

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	//enables lazyload in pdp

	var picture_lazy_load = __webpack_require__(126);
	picture_lazy_load.init();

	function hideAddToWishlistButtonInPDP() {
	    $('.product-detail .prices-add-to-cart-actions .add-to-wish-list').hide();
	}
	hideAddToWishlistButtonInPDP();

	function selectASizeHintWishList() {
	    $('.container').on('click', '.add-to-wish-list', function () {
	        var $self = $(this);
	        if (!$self.hasClass('to-add to-remove')) {

	            var $overlay = $self.parents('.product-tile').find('.js-tile-open-overlay');
	            // PLP case for VG products to not open the size drawer.
	            if ($overlay.hasClass('js-noSize') || $self.attr('data-is-size-selected') === 'null') {
	                return;
	            } else {
	                $self.closest('.cc-col-tile').addClass('js-addWishlist');
	                $overlay.trigger('click');
	            }
	        }
	    });
	}

	selectASizeHintWishList();

	//this function is to use only if variationGroups have different type of size
	// function modifyUrlColorSwatchesToSingleVariant($sizeTile) {
	//     var urlVariantValue = $sizeTile.attr('value');
	//     var sizeValue = $sizeTile.attr('data-attr-value');
	//     var $colorSwatches = $('.attributes .swatches-container .color-attribute');
	//     var urlToReplace;
	//     $colorSwatches.each(function () {
	//         var element = $(this).find('.color-value');
	//         var colorValue = element.attr('data-attr-value');
	//         urlToReplace = urlVariantValue;
	//         urlToReplace = urlToReplace.replace(/(?<=size=)(.*?)((?=&)|(?=$))/, sizeValue);
	//         urlToReplace = urlToReplace.replace(/(?<=color=)(.*?)((?=&)|(?=$))/, colorValue);
	//         $(this).attr('data-url', urlToReplace);
	//     })
	// }

	/**
	 * Retrieves the relevant pid value
	 * @param {jquery} $el - DOM container for a given add to cart button
	 * @return {string} - value to be used when adding product to cart
	 */
	function getPidValue($el) {
	    var pid;

	    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length > 0) {
	        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
	    } else if ($($el).closest('.product-tile').length > 0) {
	        pid = $($el).data('pid');
	    } else if ($($el).closest('.product-set').length > 0 || $('.product-set').length > 0) {
	        pid = $($el).closest('.product-detail').find('.product-id').text();
	    } else {
	        pid = $('.product-detail:not(".bundle-item")').data('pid');
	    }

	    return pid;
	}

	/**
	 * Makes a call to the server to report the event of adding an item to the cart
	 *
	 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
	 */
	function miniCartReportingUrl(url) {
	    if (url) {
	        $.ajax({
	            url: url,
	            method: 'GET',
	            success: function success() {
	                // reporting urls hit on the server
	            },
	            error: function error() {
	                // no reporting urls hit on the server
	            }
	        });
	    }
	}

	module.exports = {
	    getPidValue: getPidValue,
	    miniCartReportingUrl: miniCartReportingUrl
	};

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	    init: function init() {
	        //var featureDetect = require('./featureDetect');

	        var lazySizesConfig = window.lazySizesConfig = window.lazySizesConfig || {};
	        lazySizesConfig.init = false;
	        lazySizesConfig.loadMode = 2;
	        lazySizesConfig.preloadAfterLoad = false;
	        lazySizesConfig.ricTimeout = 250;
	        lazySizesConfig.expand = 700;
	        lazySizesConfig.loadHidden = false;
	        lazySizesConfig.srcAttr = 'data-lazy';
	        lazySizesConfig.srcsetAttr = 'data-srcset';
	        lazySizesConfig.sizesAttr = 'data-sizes';
	        lazySizesConfig.lazyClass = 'b-lazyload';
	        lazySizesConfig.loadingClass = 'b-lazyload_loading';
	        lazySizesConfig.loadedClass = 'b-lazyload_loaded';

	        var lazysizes = __webpack_require__(127);

	        document.addEventListener('lazybeforeunveil', function (e) {
	            var bg = e.target.getAttribute('data-bg');
	            if (bg) {
	                e.target.style.backgroundImage = 'url(' + bg + ')';
	            }
	        });

	        lazysizes.init();
	        // if (!featureDetect.hasPicture) {
	        //     import( /* webpackChunkName: "picturefill" */ 'picturefill').then((loadedModule) => {
	        //         loadedModule.default();
	        //         lazysizes.init();
	        //     });
	        // } else {
	        //     lazysizes.init();
	        // }

	    }
	};

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	(function (window, factory) {
		var lazySizes = factory(window, window.document);
		window.lazySizes = lazySizes;
		if (( false ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
			module.exports = lazySizes;
		}
	})(window, function l(window, document) {
		'use strict';
		/*jshint eqnull:true */

		if (!document.getElementsByClassName) {
			return;
		}

		var lazysizes, lazySizesConfig;

		var docElem = document.documentElement;

		var Date = window.Date;

		var supportPicture = window.HTMLPictureElement;

		var _addEventListener = 'addEventListener';

		var _getAttribute = 'getAttribute';

		var addEventListener = window[_addEventListener];

		var setTimeout = window.setTimeout;

		var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

		var requestIdleCallback = window.requestIdleCallback;

		var regPicture = /^picture$/i;

		var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

		var regClassCache = {};

		var forEach = Array.prototype.forEach;

		var hasClass = function hasClass(ele, cls) {
			if (!regClassCache[cls]) {
				regClassCache[cls] = new RegExp('(\\s|^)' + cls + '(\\s|$)');
			}
			return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
		};

		var addClass = function addClass(ele, cls) {
			if (!hasClass(ele, cls)) {
				ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
			}
		};

		var removeClass = function removeClass(ele, cls) {
			var reg;
			if (reg = hasClass(ele, cls)) {
				ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
			}
		};

		var addRemoveLoadEvents = function addRemoveLoadEvents(dom, fn, add) {
			var action = add ? _addEventListener : 'removeEventListener';
			if (add) {
				addRemoveLoadEvents(dom, fn);
			}
			loadEvents.forEach(function (evt) {
				dom[action](evt, fn);
			});
		};

		var triggerEvent = function triggerEvent(elem, name, detail, noBubbles, noCancelable) {
			var event = document.createEvent('Event');

			if (!detail) {
				detail = {};
			}

			detail.instance = lazysizes;

			event.initEvent(name, !noBubbles, !noCancelable);

			event.detail = detail;

			elem.dispatchEvent(event);
			return event;
		};

		var updatePolyfill = function updatePolyfill(el, full) {
			var polyfill;
			if (!supportPicture && (polyfill = window.picturefill || lazySizesConfig.pf)) {
				if (full && full.src && !el[_getAttribute]('srcset')) {
					el.setAttribute('srcset', full.src);
				}
				polyfill({ reevaluate: true, elements: [el] });
			} else if (full && full.src) {
				el.src = full.src;
			}
		};

		var getCSS = function getCSS(elem, style) {
			return (getComputedStyle(elem, null) || {})[style];
		};

		var getWidth = function getWidth(elem, parent, width) {
			width = width || elem.offsetWidth;

			while (width < lazySizesConfig.minSize && parent && !elem._lazysizesWidth) {
				width = parent.offsetWidth;
				parent = parent.parentNode;
			}

			return width;
		};

		var rAF = function () {
			var running, waiting;
			var firstFns = [];
			var secondFns = [];
			var fns = firstFns;

			var run = function run() {
				var runFns = fns;

				fns = firstFns.length ? secondFns : firstFns;

				running = true;
				waiting = false;

				while (runFns.length) {
					runFns.shift()();
				}

				running = false;
			};

			var rafBatch = function rafBatch(fn, queue) {
				if (running && !queue) {
					fn.apply(this, arguments);
				} else {
					fns.push(fn);

					if (!waiting) {
						waiting = true;
						(document.hidden ? setTimeout : requestAnimationFrame)(run);
					}
				}
			};

			rafBatch._lsFlush = run;

			return rafBatch;
		}();

		var rAFIt = function rAFIt(fn, simple) {
			return simple ? function () {
				rAF(fn);
			} : function () {
				var that = this;
				var args = arguments;
				rAF(function () {
					fn.apply(that, args);
				});
			};
		};

		var throttle = function throttle(fn) {
			var running;
			var lastTime = 0;
			var gDelay = lazySizesConfig.throttleDelay;
			var rICTimeout = lazySizesConfig.ricTimeout;
			var run = function run() {
				running = false;
				lastTime = Date.now();
				fn();
			};
			var idleCallback = requestIdleCallback && rICTimeout > 49 ? function () {
				requestIdleCallback(run, { timeout: rICTimeout });

				if (rICTimeout !== lazySizesConfig.ricTimeout) {
					rICTimeout = lazySizesConfig.ricTimeout;
				}
			} : rAFIt(function () {
				setTimeout(run);
			}, true);

			return function (isPriority) {
				var delay;

				if (isPriority = isPriority === true) {
					rICTimeout = 33;
				}

				if (running) {
					return;
				}

				running = true;

				delay = gDelay - (Date.now() - lastTime);

				if (delay < 0) {
					delay = 0;
				}

				if (isPriority || delay < 9) {
					idleCallback();
				} else {
					setTimeout(idleCallback, delay);
				}
			};
		};

		//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
		var debounce = function debounce(func) {
			var timeout, timestamp;
			var wait = 99;
			var run = function run() {
				timeout = null;
				func();
			};
			var later = function later() {
				var last = Date.now() - timestamp;

				if (last < wait) {
					setTimeout(later, wait - last);
				} else {
					(requestIdleCallback || run)(run);
				}
			};

			return function () {
				timestamp = Date.now();

				if (!timeout) {
					timeout = setTimeout(later, wait);
				}
			};
		};

		(function () {
			var prop;

			var lazySizesDefaults = {
				lazyClass: 'lazyload',
				loadedClass: 'lazyloaded',
				loadingClass: 'lazyloading',
				preloadClass: 'lazypreload',
				errorClass: 'lazyerror',
				//strictClass: 'lazystrict',
				autosizesClass: 'lazyautosizes',
				srcAttr: 'data-src',
				srcsetAttr: 'data-srcset',
				sizesAttr: 'data-sizes',
				//preloadAfterLoad: false,
				minSize: 40,
				customMedia: {},
				init: true,
				expFactor: 1.5,
				hFac: 0.8,
				loadMode: 2,
				loadHidden: true,
				ricTimeout: 0,
				throttleDelay: 125
			};

			lazySizesConfig = window.lazySizesConfig || window.lazysizesConfig || {};

			for (prop in lazySizesDefaults) {
				if (!(prop in lazySizesConfig)) {
					lazySizesConfig[prop] = lazySizesDefaults[prop];
				}
			}

			window.lazySizesConfig = lazySizesConfig;

			setTimeout(function () {
				if (lazySizesConfig.init) {
					init();
				}
			});
		})();

		var loader = function () {
			var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

			var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

			var regImg = /^img$/i;
			var regIframe = /^iframe$/i;

			var supportScroll = 'onscroll' in window && !/(gle|ing)bot/.test(navigator.userAgent);

			var shrinkExpand = 0;
			var currentExpand = 0;

			var isLoading = 0;
			var lowRuns = -1;

			var resetPreloading = function resetPreloading(e) {
				isLoading--;
				if (!e || isLoading < 0 || !e.target) {
					isLoading = 0;
				}
			};

			var isVisible = function isVisible(elem) {
				if (isBodyHidden == null) {
					isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
				}

				return isBodyHidden || getCSS(elem.parentNode, 'visibility') != 'hidden' && getCSS(elem, 'visibility') != 'hidden';
			};

			var isNestedVisible = function isNestedVisible(elem, elemExpand) {
				var outerRect;
				var parent = elem;
				var visible = isVisible(elem);

				eLtop -= elemExpand;
				eLbottom += elemExpand;
				eLleft -= elemExpand;
				eLright += elemExpand;

				while (visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem) {
					visible = (getCSS(parent, 'opacity') || 1) > 0;

					if (visible && getCSS(parent, 'overflow') != 'visible') {
						outerRect = parent.getBoundingClientRect();
						visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
					}
				}

				return visible;
			};

			var checkElements = function checkElements() {
				var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac;
				var lazyloadElems = lazysizes.elements;

				if ((loadMode = lazySizesConfig.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {

					i = 0;

					lowRuns++;

					defaultExpand = !lazySizesConfig.expand || lazySizesConfig.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesConfig.expand;

					lazysizes._defEx = defaultExpand;

					preloadExpand = defaultExpand * lazySizesConfig.expFactor;
					hFac = lazySizesConfig.hFac;
					isBodyHidden = null;

					if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden) {
						currentExpand = preloadExpand;
						lowRuns = 0;
					} else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) {
						currentExpand = defaultExpand;
					} else {
						currentExpand = shrinkExpand;
					}

					for (; i < eLlen; i++) {

						if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) {
							continue;
						}

						if (!supportScroll) {
							unveilElement(lazyloadElems[i]);continue;
						}

						if (!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)) {
							elemExpand = currentExpand;
						}

						if (beforeExpandVal !== elemExpand) {
							eLvW = innerWidth + elemExpand * hFac;
							elvH = innerHeight + elemExpand;
							elemNegativeExpand = elemExpand * -1;
							beforeExpandVal = elemExpand;
						}

						rect = lazyloadElems[i].getBoundingClientRect();

						if ((eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesConfig.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
							unveilElement(lazyloadElems[i]);
							loadedSomething = true;
							if (isLoading > 9) {
								break;
							}
						} else if (!loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesConfig.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesConfig.sizesAttr) != 'auto'))) {
							autoLoadElem = preloadElems[0] || lazyloadElems[i];
						}
					}

					if (autoLoadElem && !loadedSomething) {
						unveilElement(autoLoadElem);
					}
				}
			};

			var throttledCheckElements = throttle(checkElements);

			var switchLoadingClass = function switchLoadingClass(e) {
				var elem = e.target;

				if (elem._lazyCache) {
					delete elem._lazyCache;
					return;
				}

				resetPreloading(e);
				addClass(elem, lazySizesConfig.loadedClass);
				removeClass(elem, lazySizesConfig.loadingClass);
				addRemoveLoadEvents(elem, rafSwitchLoadingClass);
				triggerEvent(elem, 'lazyloaded');
			};
			var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
			var rafSwitchLoadingClass = function rafSwitchLoadingClass(e) {
				rafedSwitchLoadingClass({ target: e.target });
			};

			var changeIframeSrc = function changeIframeSrc(elem, src) {
				try {
					elem.contentWindow.location.replace(src);
				} catch (e) {
					elem.src = src;
				}
			};

			var handleSources = function handleSources(source) {
				var customMedia;

				var sourceSrcset = source[_getAttribute](lazySizesConfig.srcsetAttr);

				if (customMedia = lazySizesConfig.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) {
					source.setAttribute('media', customMedia);
				}

				if (sourceSrcset) {
					source.setAttribute('srcset', sourceSrcset);
				}
			};

			var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg) {
				var src, srcset, parent, isPicture, event, firesLoad;

				if (!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented) {

					if (sizes) {
						if (isAuto) {
							addClass(elem, lazySizesConfig.autosizesClass);
						} else {
							elem.setAttribute('sizes', sizes);
						}
					}

					srcset = elem[_getAttribute](lazySizesConfig.srcsetAttr);
					src = elem[_getAttribute](lazySizesConfig.srcAttr);

					if (isImg) {
						parent = elem.parentNode;
						isPicture = parent && regPicture.test(parent.nodeName || '');
					}

					firesLoad = detail.firesLoad || 'src' in elem && (srcset || src || isPicture);

					event = { target: elem };

					addClass(elem, lazySizesConfig.loadingClass);

					if (firesLoad) {
						clearTimeout(resetPreloadingTimer);
						resetPreloadingTimer = setTimeout(resetPreloading, 2500);
						addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
					}

					if (isPicture) {
						forEach.call(parent.getElementsByTagName('source'), handleSources);
					}

					if (srcset) {
						elem.setAttribute('srcset', srcset);
					} else if (src && !isPicture) {
						if (regIframe.test(elem.nodeName)) {
							changeIframeSrc(elem, src);
						} else {
							elem.src = src;
						}
					}

					if (isImg && (srcset || isPicture)) {
						updatePolyfill(elem, { src: src });
					}
				}

				if (elem._lazyRace) {
					delete elem._lazyRace;
				}
				removeClass(elem, lazySizesConfig.lazyClass);

				rAF(function () {
					// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
					var isLoaded = elem.complete && elem.naturalWidth > 1;

					if (!firesLoad || isLoaded) {
						if (isLoaded) {
							addClass(elem, 'ls-is-cached');
						}
						switchLoadingClass(event);
						elem._lazyCache = true;
						setTimeout(function () {
							if ('_lazyCache' in elem) {
								delete elem._lazyCache;
							}
						}, 9);
					}
				}, true);
			});

			var unveilElement = function unveilElement(elem) {
				var detail;

				var isImg = regImg.test(elem.nodeName);

				//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
				var sizes = isImg && (elem[_getAttribute](lazySizesConfig.sizesAttr) || elem[_getAttribute]('sizes'));
				var isAuto = sizes == 'auto';

				if ((isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesConfig.errorClass) && hasClass(elem, lazySizesConfig.lazyClass)) {
					return;
				}

				detail = triggerEvent(elem, 'lazyunveilread').detail;

				if (isAuto) {
					autoSizer.updateElem(elem, true, elem.offsetWidth);
				}

				elem._lazyRace = true;
				isLoading++;

				lazyUnveil(elem, detail, isAuto, sizes, isImg);
			};

			var onload = function onload() {
				if (isCompleted) {
					return;
				}
				if (Date.now() - started < 999) {
					setTimeout(onload, 999);
					return;
				}
				var afterScroll = debounce(function () {
					lazySizesConfig.loadMode = 3;
					throttledCheckElements();
				});

				isCompleted = true;

				lazySizesConfig.loadMode = 3;

				throttledCheckElements();

				addEventListener('scroll', function () {
					if (lazySizesConfig.loadMode == 3) {
						lazySizesConfig.loadMode = 2;
					}
					afterScroll();
				}, true);
			};

			return {
				_: function _() {
					started = Date.now();

					lazysizes.elements = document.getElementsByClassName(lazySizesConfig.lazyClass);
					preloadElems = document.getElementsByClassName(lazySizesConfig.lazyClass + ' ' + lazySizesConfig.preloadClass);

					addEventListener('scroll', throttledCheckElements, true);

					addEventListener('resize', throttledCheckElements, true);

					if (window.MutationObserver) {
						new MutationObserver(throttledCheckElements).observe(docElem, { childList: true, subtree: true, attributes: true });
					} else {
						docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
						docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
						setInterval(throttledCheckElements, 999);
					}

					addEventListener('hashchange', throttledCheckElements, true);

					//, 'fullscreenchange'
					['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend', 'webkitAnimationEnd'].forEach(function (name) {
						document[_addEventListener](name, throttledCheckElements, true);
					});

					if (/d$|^c/.test(document.readyState)) {
						onload();
					} else {
						addEventListener('load', onload);
						document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
						setTimeout(onload, 20000);
					}

					if (lazysizes.elements.length) {
						checkElements();
						rAF._lsFlush();
					} else {
						throttledCheckElements();
					}
				},
				checkElems: throttledCheckElements,
				unveil: unveilElement
			};
		}();

		var autoSizer = function () {
			var autosizesElems;

			var sizeElement = rAFIt(function (elem, parent, event, width) {
				var sources, i, len;
				elem._lazysizesWidth = width;
				width += 'px';

				elem.setAttribute('sizes', width);

				if (regPicture.test(parent.nodeName || '')) {
					sources = parent.getElementsByTagName('source');
					for (i = 0, len = sources.length; i < len; i++) {
						sources[i].setAttribute('sizes', width);
					}
				}

				if (!event.detail.dataAttr) {
					updatePolyfill(elem, event.detail);
				}
			});
			var getSizeElement = function getSizeElement(elem, dataAttr, width) {
				var event;
				var parent = elem.parentNode;

				if (parent) {
					width = getWidth(elem, parent, width);
					event = triggerEvent(elem, 'lazybeforesizes', { width: width, dataAttr: !!dataAttr });

					if (!event.defaultPrevented) {
						width = event.detail.width;

						if (width && width !== elem._lazysizesWidth) {
							sizeElement(elem, parent, event, width);
						}
					}
				}
			};

			var updateElementsSizes = function updateElementsSizes() {
				var i;
				var len = autosizesElems.length;
				if (len) {
					i = 0;

					for (; i < len; i++) {
						getSizeElement(autosizesElems[i]);
					}
				}
			};

			var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

			return {
				_: function _() {
					autosizesElems = document.getElementsByClassName(lazySizesConfig.autosizesClass);
					addEventListener('resize', debouncedUpdateElementsSizes);
				},
				checkElems: debouncedUpdateElementsSizes,
				updateElem: getSizeElement
			};
		}();

		var init = function init() {
			if (!init.i) {
				init.i = true;
				autoSizer._();
				loader._();
			}
		};

		lazysizes = {
			cfg: lazySizesConfig,
			autoSizer: autoSizer,
			loader: loader,
			init: init,
			uP: updatePolyfill,
			aC: addClass,
			rC: removeClass,
			hC: hasClass,
			fire: triggerEvent,
			gW: getWidth,
			rAF: rAF
		};

		return lazysizes;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(104)(module)))

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var focusHelper = __webpack_require__(120);

	/**
	 * Parses the html for a modal window
	 * @param {string} html - representing the body and footer of the modal window
	 *
	 * @return {Object} - Object with properties body and footer.
	 */
	function parseHtml(html) {
	    var $html = $('<div>').append($.parseHTML(html));

	    var body = $html.find('.choice-of-bonus-product');
	    var footer = $html.find('.modal-footer').children();

	    return {
	        body: body,
	        footer: footer
	    };
	}

	/**
	 * Retrieves url to use when adding a product to the cart
	 *
	 * @param {Object} data - data object used to fill in dynamic portions of the html
	 */
	function chooseBonusProducts(data) {
	    $('.modal-body').spinner().start();

	    if ($('#chooseBonusProductModal').length !== 0) {
	        $('#chooseBonusProductModal').remove();
	    }
	    var bonusUrl;
	    if (data.bonusChoiceRuleBased) {
	        bonusUrl = data.showProductsUrlRuleBased;
	    } else {
	        bonusUrl = data.showProductsUrlListBased;
	    }

	    var htmlString = '<!-- Modal -->' + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">' + '<span class="enter-message sr-only" ></span>' + '<div class="modal-dialog choose-bonus-product-dialog" ' + 'data-total-qty="' + data.maxBonusItems + '"' + 'data-UUID="' + data.uuid + '"' + 'data-pliUUID="' + data.pliUUID + '"' + 'data-addToCartUrl="' + data.addToCartUrl + '"' + 'data-pageStart="0"' + 'data-pageSize="' + data.pageSize + '"' + 'data-moreURL="' + data.showProductsUrlRuleBased + '"' + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">' + '<!-- Modal content-->' + '<div class="modal-content">' + '<div class="modal-header">' + '    <span class="">' + data.labels.selectprods + '</span>' + '    <button type="button" class="close pull-right" data-dismiss="modal">' + '        <span aria-hidden="true">&times;</span>' + '        <span class="sr-only"> </span>' + '    </button>' + '</div>' + '<div class="modal-body"></div>' + '<div class="modal-footer"></div>' + '</div>' + '</div>' + '</div>';
	    $('body').append(htmlString);
	    $('.modal-body').spinner().start();

	    $.ajax({
	        url: bonusUrl,
	        method: 'GET',
	        dataType: 'json',
	        success: function success(response) {
	            var parsedHtml = parseHtml(response.renderedTemplate);
	            $('#chooseBonusProductModal .modal-body').empty();
	            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
	            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
	            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
	            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
	            $('#chooseBonusProductModal').modal('show');
	            $.spinner().stop();
	        },
	        error: function error() {
	            $.spinner().stop();
	        }
	    });
	}

	module.exports = {

	    methods: {
	        editBonusProducts: function editBonusProducts(data) {
	            chooseBonusProducts(data);
	        }
	    },

	    chooseBonusProducts: chooseBonusProducts,

	    focusChooseBonusProductModal: function focusChooseBonusProductModal() {
	        $('body').on('shown.bs.modal', '#chooseBonusProductModal', function () {
	            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'true');
	            $('#chooseBonusProductModal .close').focus();
	        });
	    },

	    onClosingChooseBonusProductModal: function onClosingChooseBonusProductModal() {
	        $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
	            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'false');
	        });
	    },

	    trapChooseBonusProductModalFocus: function trapChooseBonusProductModalFocus() {
	        $('body').on('keydown', '#chooseBonusProductModal', function (e) {
	            var focusParams = {
	                event: e,
	                containerSelector: '#chooseBonusProductModal',
	                firstElementSelector: '.close',
	                lastElementSelector: '.add-bonus-products'
	            };
	            focusHelper.setTabNextFocus(focusParams);
	        });
	    },

	    selectBonusProduct: function selectBonusProduct() {
	        $(document).on('click', '.select-bonus-product', function () {
	            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
	            var pid = $(this).data('pid');
	            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
	            var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
	            var totalQty = 0;
	            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
	                totalQty += $(this).data('qty');
	            });
	            totalQty += submittedQty;
	            var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
	            var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
	            if (totalQty <= maxPids) {
	                var selectedBonusProductHtml = '' + '<div class="selected-pid row" ' + 'data-pid="' + pid + '"' + 'data-qty="' + submittedQty + '"' + 'data-optionID="' + (optionID || '') + '"' + 'data-option-selected-value="' + (valueId || '') + '"' + '>' + '<div class="col-sm-11 col-9 bonus-product-name" >' + $choiceOfBonusProduct.find('.product-name').html() + '</div>' + '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>' + '</div>';
	                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
	                $('.pre-cart-products').html(totalQty);
	                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
	            } else {
	                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
	            }
	        });
	    },
	    removeBonusProduct: function removeBonusProduct() {
	        $(document).on('click', '.selected-pid', function () {
	            $(this).remove();
	            var $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
	            var count = 0;
	            if ($selected.length) {
	                $selected.each(function () {
	                    count += parseInt($(this).data('qty'), 10);
	                });
	            }

	            $('.pre-cart-products').html(count);
	            $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
	        });
	    },
	    enableBonusProductSelection: function enableBonusProductSelection() {
	        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
	            $('button.select-bonus-product', response.$productContainer).attr('disabled', !response.product.readyToOrder || !response.product.available);
	            var pid = response.product.id;
	            $('button.select-bonus-product', response.$productContainer).data('pid', pid);
	        });
	    },
	    showMoreBonusProducts: function showMoreBonusProducts() {
	        $(document).on('click', '.show-more-bonus-products', function () {
	            var url = $(this).data('url');
	            $('.modal-content').spinner().start();
	            $.ajax({
	                url: url,
	                method: 'GET',
	                success: function success(html) {
	                    var parsedHtml = parseHtml(html);
	                    $('.modal-body').append(parsedHtml.body);
	                    $('.show-more-bonus-products:first').remove();
	                    $('.modal-content').spinner().stop();
	                },
	                error: function error() {
	                    $('.modal-content').spinner().stop();
	                }
	            });
	        });
	    },
	    addBonusProductsToCart: function addBonusProductsToCart() {
	        $(document).on('click', '.add-bonus-products', function () {
	            var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
	            var queryString = '?pids=';
	            var url = $('.choose-bonus-product-dialog').data('addtocarturl');
	            var pidsObject = {
	                bonusProducts: []
	            };

	            $.each($readyToOrderBonusProducts, function () {
	                var qtyOption = parseInt($(this).data('qty'), 10);

	                var option = null;
	                if (qtyOption > 0) {
	                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
	                        option = {};
	                        option.optionId = $(this).data('optionid');
	                        option.productId = $(this).data('pid');
	                        option.selectedValueId = $(this).data('option-selected-value');
	                    }
	                    pidsObject.bonusProducts.push({
	                        pid: $(this).data('pid'),
	                        qty: qtyOption,
	                        options: [option]
	                    });
	                    pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
	                }
	            });
	            queryString += JSON.stringify(pidsObject);
	            queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
	            queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
	            $.spinner().start();
	            $.ajax({
	                url: url + queryString,
	                method: 'POST',
	                success: function success(data) {
	                    $.spinner().stop();
	                    if (data.error) {
	                        $('#chooseBonusProductModal').modal('hide');
	                        if ($('.add-to-cart-messages').length === 0) {
	                            $('body').append('<div class="add-to-cart-messages"></div>');
	                        }
	                        $('.add-to-cart-messages').append('<div class="alert alert-danger add-to-basket-alert text-center"' + ' role="alert">' + data.errorMessage + '</div>');
	                        setTimeout(function () {
	                            $('.add-to-basket-alert').remove();
	                        }, 3000);
	                    } else {
	                        $('.configure-bonus-product-attributes').html(data);
	                        $('.bonus-products-step2').removeClass('hidden-xl-down');
	                        $('#chooseBonusProductModal').modal('hide');

	                        if ($('.add-to-cart-messages').length === 0) {
	                            $('body').append('<div class="add-to-cart-messages"></div>');
	                        }
	                        $('.minicart-quantity').html(data.totalQty);
	                        $('.add-to-cart-messages').append('<div class="alert alert-success add-to-basket-alert text-center"' + ' role="alert">' + data.msgSuccess + '</div>');
	                        setTimeout(function () {
	                            $('.add-to-basket-alert').remove();
	                            if ($('.cart-page').length) {
	                                location.reload();
	                            }
	                        }, 1500);
	                    }
	                },
	                error: function error() {
	                    $.spinner().stop();
	                }
	            });
	        });
	    }
	};

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var addToCartHelper = __webpack_require__(154);

	function actionAfterSelectSize(classToRefresh) {
	    var $objTile = $('.' + classToRefresh.replaceAll(' ', '.'));
	    var $btnAddToCart = $objTile.find('.add-to-cart');
	    var $wishlistBtn = $objTile.find('.add-to-wish-list');

	    if ($objTile.closest('.cc-col-tile').hasClass('js-addWishlist')) {
	        $wishlistBtn.trigger('click');
	        $objTile.closest('.cc-col-tile').removeClass('js-addWishlist');
	    } else {
	        $btnAddToCart.trigger('click');
	    }

	    $('.js-sizeBtn').removeClass('active');
	    $('body').removeClass('modal-open');
	}

	//Modify the wishlist-add button like normal behavior, if the product can be added or not
	function handleWishlistButtonInTile($element, isInWishlist) {

	    var $button = $element.find('button.add-to-wish-list');
	    var isSizeSelected = !!$button.data('is-size-selected');
	    var isCarouselProductAlreadyWishlisted = false;
	    // Checking if the product is already wishlisted in carousel/recommendation component
	    if (window.ProductsInWishlist) {
	        var productArr = window.ProductsInWishlist;
	        var pid = $button.data('pid');
	        isCarouselProductAlreadyWishlisted = productArr.indexOf(pid) !== -1;
	    }
	    var $spanAdd = $button.find('span.wishlist-content-add').length ? $button.find('span.wishlist-content-add') : $button.find('svg.wishlist-content-add');
	    var $spanRemove = $button.find('span.wishlist-content-remove').length ? $button.find('span.wishlist-content-remove') : $button.find('svg.wishlist-content-remove');

	    if (isSizeSelected || isCarouselProductAlreadyWishlisted) {
	        if (isInWishlist) {
	            $button.addClass('to-remove');
	            $button.removeClass('to-add');
	            $button.attr('data-variation-group', 'to-remove');

	            $spanAdd.addClass('d-none');
	            $spanRemove.removeClass('d-none');
	        } else {
	            $button.addClass('to-add');
	            $button.removeClass('to-remove');
	            $button.attr('data-variation-group', 'to-add');

	            $spanRemove.addClass('d-none');
	            $spanAdd.removeClass('d-none');
	        }
	    }
	}

	//this function check if the pid in argument is included in the array of products' PID in wishlist
	function checkInWishlist(classToRefresh) {
	    var productArr = window.ProductsInWishlist;

	    if (!productArr) {
	        return false;
	    }

	    var $element = $('.' + classToRefresh.replaceAll(' ', '.')).find('.product.product-tile');
	    var newPid = $element.data('pid');
	    if (productArr.indexOf(newPid) > -1) {
	        handleWishlistButtonInTile($element, true);
	    } else {
	        handleWishlistButtonInTile($element, false);
	    }
	}

	function scrollActiveColorsIntoView() {
	    $('.cc-color-link-content-activate.active').each(function () {
	        var $selectedColor = $(this);
	        var $colorContainer = $selectedColor.closest('.cc-color');
	        if ($colorContainer.length > 0) {
	            var containerWidth = $colorContainer.width();
	            var selectedColorLeft = $selectedColor.position().left;
	            var selectedColorWidth = $selectedColor.outerWidth();

	            if (selectedColorLeft < 0 || selectedColorLeft + selectedColorWidth > containerWidth) {
	                var scrollTo = selectedColorLeft - containerWidth / 2 + selectedColorWidth / 2;
	                $colorContainer.scrollLeft(Math.max(0, scrollTo));
	            }
	        }
	    });
	}

	$('.cc-recommended-slider, .js-slider, .cc-cart-container, .js-editorial-pdp').on('click', '.changeTileSelection a', function (e) {
	    e.preventDefault();
	    e.stopPropagation();

	    var classToRefresh = $(this).closest('.js-tile').length > 0 ? $(this).closest('.js-tile').attr('class') : $(this).closest('.cc-col-tile').attr('class');

	    var isSize = true;
	    var attrColor = $(this).attr('data-color');
	    if (typeof attrColor !== 'undefined' && attrColor !== false) {
	        isSize = false;
	    }

	    $.ajax({
	        url: $(this).data('refreshtileurl'),
	        data: {
	            selectedUrl: $(this).data('refreshtileurl'),
	            classToRefresh: classToRefresh,
	            isAjax: true,
	            isSize: isSize
	        },
	        method: 'GET',
	        success: function success(response) {
	            $('.' + classToRefresh.replaceAll(' ', '.')).empty().html(response);
	            checkInWishlist(classToRefresh);
	            var $tile = $('.' + classToRefresh.replaceAll(' ', '.'));
	            var $wishlistBtn = $tile.find('.add-to-wish-list');
	            var $productTile = $wishlistBtn.closest('.product-tile');
	            if ($wishlistBtn.length && !$productTile.hasClass('to-add') && !$wishlistBtn.hasClass('to-remove')) {
	                $productTile.find('.cc-tile-add-to-wishlist').addClass('to-add');
	            }
	            // Add manual club price product badge icon
	            $('.cc-label-clubprice').addClass('icon-bata-club-price-cz');

	            if (isSize) {
	                actionAfterSelectSize(classToRefresh);
	            } else {
	                scrollActiveColorsIntoView();
	            }
	        },
	        error: function error() {
	            $.spinner().stop();
	        }
	    });
	});

	// Tile sizes
	$(document).on('click', '.cc-recommended-grid__item .js-tile-open-overlay, .cc-page-designer .js-tile-open-overlay', function (e) {
	    e.stopPropagation();
	    e.preventDefault();

	    var $self = $(this);
	    if ($self.hasClass('js-noSize')) {
	        $self.closest('.cc-col-tile').find('.add-to-cart').trigger('click');
	    } else {
	        $('.js-tileWrapper').removeClass('js-tileWrapperHover');
	        $('.cc-tile-sizes.cc-active').removeClass('cc-active');
	        $self.closest('.cc-col-tile').find('.cc-tile-sizes').addClass('cc-active');
	        $self.closest('.js-tileWrapper').addClass('js-tileWrapperHover');

	        if (!window.isDesktop) {
	            $('body').addClass('modal-open');
	            if ($self.closest('.experience-commerce_carousel_product-productListContentSlot').length > 0) {
	                $self.closest('.experience-commerce_carousel_product-productListContentSlot').css('z-index', '5');
	            }
	        }
	    }
	});

	$('.container, .js-editorial-pdp').on('mouseleave', '.js-tileWrapperHover', function () {
	    if (window.isDesktop) {
	        var $self = $(this);

	        $self.removeClass('js-tileWrapperHover');
	        $self.find('.cc-tile-sizes').removeClass('cc-active');
	        $('.experience-commerce_carousel_product-productListContentSlot').css('z-index', '1');
	    }
	});

	$(document).on('click', '.js-arrow-next', function () {
	    var $slider = $('.js-recommendedSlider');
	    var scrollStep = 200;

	    $slider.animate({
	        scrollLeft: $slider.scrollLeft() + scrollStep
	    }, 300, function () {
	        var scrollLeft = $slider.scrollLeft();
	        var scrollWidth = $slider[0].scrollWidth;
	        var offsetWidth = $slider[0].offsetWidth;

	        if (scrollLeft + offsetWidth >= scrollWidth - 5) {
	            $('.js-arrow-next').addClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	        } else {
	            $('.js-arrow-next').removeClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	        }

	        $('.js-arrow-prev').removeClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	    });
	});

	$(document).on('click', '.js-arrow-prev', function () {
	    var $this = $(this);
	    var $slider = $('.js-recommendedSlider');
	    var scrollStep = 200;

	    $slider.animate({
	        scrollLeft: $slider.scrollLeft() - scrollStep
	    }, 300, function () {
	        var scrollLeft = $slider.scrollLeft();

	        if (scrollLeft <= 5) {
	            $this.addClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	        } else {
	            $this.removeClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	        }

	        $('.js-arrow-next').removeClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	    });
	});

	$('.js-recommendedSlider').on('scroll', function () {
	    var $slider = $(this);
	    var scrollLeft = $slider.scrollLeft();
	    var scrollWidth = $slider[0].scrollWidth;
	    var offsetWidth = $slider[0].offsetWidth;

	    if (scrollLeft + offsetWidth >= scrollWidth - 5) {
	        $('.js-arrow-next').addClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	    } else {
	        $('.js-arrow-next').removeClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	    }

	    if (scrollLeft <= 5) {
	        $('.js-arrow-prev').addClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	    } else {
	        $('.js-arrow-prev').removeClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	    }
	});

	$(function () {
	    scrollActiveColorsIntoView();
	});

	module.exports = {
	    addToCart: addToCartHelper.addToCart
	};

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var base = __webpack_require__(125),
	    bonusProductHelpers = __webpack_require__(142),
	    detectDevice = __webpack_require__(155);

	function sizeIsSelectedFunc($elem) {
	    var isDisabled = $elem.data('is-disabled');
	    var isOneSizePLP = $elem.parents('.cc-content-button').prev('.color-swatches').find('.select-size').length <= 0;
	    var isOneSizePDP = $elem.parents('.pdp-col-description').find('.container-size-list').length <= 0;

	    if ((isDisabled === true || isDisabled === 'true') && (!isOneSizePLP || !isOneSizePDP)) {
	        // if button is disabled and prod is not a oneSize prod, no msg hint'll be shown
	        var $hintPdp = $elem.parents('.product-detail').find('.availability-msg .availability-msg-hint');
	        var $hintPlp = $elem.parents('.container-tile-hover').find('.availability-msg .availability-msg-hint');
	        var $hint = $hintPdp.add($hintPlp);
	        $hint.removeClass('d-none');
	        var hintText = $hint.text().trim();
	        var $liveRegion = $('<div aria-live="assertive" aria-atomic="true" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;"></div>').appendTo('body');
	        setTimeout(function () {
	            $liveRegion.text(hintText);
	            setTimeout(function () {
	                $liveRegion.remove();
	            }, 1000);
	        }, 100);
	        return false;
	    } else {
	        return true;
	    }
	}

	/**
	 * Retrieve product options
	 *
	 * @param {jQuery} $productContainer - DOM element for current product
	 * @return {string} - Product options and their selected values
	 */
	function getOptions($productContainer) {
	    var options = $productContainer.find('.product-option').map(function () {
	        var $elOption = $(this).find('.options-select');
	        var urlValue = $elOption.val();
	        var selectedValueId = $elOption.find('option[value="' + urlValue + '"]').data('value-id');
	        return {
	            optionId: $(this).data('option-id'),
	            selectedValueId: selectedValueId
	        };
	    }).toArray();

	    return JSON.stringify(options);
	}

	/**
	 * Retrieves url to use when adding a product to the cart
	 *
	 * @return {string} - The provided URL to use when adding a product to the cart
	 */
	function getAddToCartUrl() {
	    return $('.add-to-cart-url').val();
	}

	/**
	 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
	 * items with their selected variants
	 *
	 * @return {string[]} - List of selected bundle product item ID's
	 */
	function getChildProducts() {
	    var childProducts = [];
	    $('.bundle-item').each(function () {
	        childProducts.push({
	            pid: $(this).find('.product-id').text(),
	            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
	        });
	    });

	    return childProducts.length ? JSON.stringify(childProducts) : [];
	}

	/**
	 * Retrieve contextual quantity selector
	 * @param {jquery} $el - DOM container for the relevant quantity
	 * @return {jquery} - quantity selector DOM container
	 */
	function getQuantitySelector($el) {
	    return $el && $('.set-items').length ? $($el).closest('.product-detail').find('.quantity-select') : $('.quantity-select');
	}

	/**
	 * Retrieves the value associated with the Quantity pull-down menu
	 * @param {jquery} $el - DOM container for the relevant quantity
	 * @return {string} - value found in the quantity input
	 */
	function getQuantitySelected($el) {
	    return getQuantitySelector($el).val();
	}

	/**
	 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
	 * @param {string} response - ajax response from clicking the add to cart button
	 */
	function handlePostCartAdd(response) {
	    $('.minicart').trigger('count:update', response);
	    var messageType = response.error ? 'alert-danger' : 'alert-success';
	    // show add to cart toast
	    if (response.newBonusDiscountLineItem && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
	        bonusProductHelpers.chooseBonusProducts(response.newBonusDiscountLineItem);
	    } else {
	        if ($('.add-to-cart-messages').length === 0) {
	            $('body').append('<div class="add-to-cart-messages"></div>');
	        }
	        var addedMsg = $('button.add-to-cart').data('added-msg') || response.message;
	        var $liveRegion = $('<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="status" aria-live="polite" aria-atomic="true"></div>');
	        $liveRegion.appendTo($('.add-to-cart-messages'));
	        setTimeout(function () {
	            $liveRegion.text(addedMsg);
	        }, 100);
	        setTimeout(function () {
	            $liveRegion.remove();
	        }, 5000);
	    }
	}

	function showMiniCart(reportingURL) {
	    return new $.Deferred(function (deferred) {
	        base.miniCartReportingUrl(reportingURL);
	        $('.cc-minicart-overlay').addClass('opened-by-add-to-bag');
	        var minicartTimeout = parseInt($('#minicartIcon').data('timeout'));

	        if (minicartTimeout > 0) {
	            setTimeout(function () {
	                if ($('.cc-minicart-overlay').hasClass('opened-by-add-to-bag')) {
	                    $('#closeMiniCartButton').click();
	                    $('.cc-minicart-overlay').removeClass('opened-by-add-to-bag');
	                    deferred.resolve();
	                }

	                if ($('.js-header').hasClass('cc-header__tag__viewHeader') && window.isDesktop) {
	                    $('.js-header').removeClass('cc-header__tag__viewHeader');

	                    // Check if we're on brandHomepage
	                    var isBrandHomepage = $('.cc-brandHomepage').length > 0;

	                    if (isBrandHomepage) {
	                        // For brandHomepage, reset miniCart and intro positioning
	                        $('.cc-minicart-overlay').css('top', '');
	                        $('.experience-commerce_layouts-intro').css('top', '-1px');
	                    } else {
	                        // For PLP pages, use existing cleanup logic
	                        var $breadcrumbContainer = $('.js-breadcrumbContainer');
	                        var $filterWrapper = $('.cc-plp--filters--sticky');
	                        var breadcrumbHeigth = $breadcrumbContainer.find('.cc-breadcrumb--container').height() > 0 ? 0 : 42;
	                        var $categoryWrapperInner = $('.js-categoryPills');
	                        var $categoryWrapper = $('.cc-plp--categories--sticky');
	                        var heightFilter = 52;
	                        var logoHeight = $('.cc-plp--filters--brandLogo').length > 0 && $('.cc-plp--categories--dropdown--withLogo--withoutCategories').length === 0 && $(window).width() < 1201 ? $('.cc-plp--filters--brandLogo').height() + 4 : 0;

	                        $breadcrumbContainer.css('top', 0);
	                        if ($categoryWrapperInner.length > 0) {
	                            $categoryWrapper.css('top', 42 - breadcrumbHeigth);
	                            $filterWrapper.css('top', 117 + logoHeight - breadcrumbHeigth);
	                        } else {
	                            if ($breadcrumbContainer.find('.cc-breadcrumb--container').length === 0) {
	                                $filterWrapper.css('top', 0);
	                            } else {
	                                $filterWrapper.css('top', heightFilter - breadcrumbHeigth);
	                            }
	                        }
	                    }
	                }
	            }, minicartTimeout);
	        }
	    }).promise();
	}

	module.exports = {
	    addToCart: function addToCart() {
	        $('.container').on('click', 'button.add-to-cart, button.add-to-cart-global', function (e) {
	            e.preventDefault();
	            e.stopPropagation();
	            e.stopImmediatePropagation();

	            var addToCartUrl;
	            var pid;
	            var pidsObj;
	            var setPids;

	            var $self = $(this);

	            var sizeIsSelected = sizeIsSelectedFunc($self);
	            if (!sizeIsSelected) {
	                return;
	            }

	            $('body').trigger('product:beforeAddToCart', this);

	            if ($('.set-items').length && $self.hasClass('add-to-cart-global')) {
	                setPids = [];

	                $('.product-detail').each(function () {
	                    if (!$self.hasClass('product-set-detail')) {
	                        setPids.push({
	                            pid: $self.find('.product-id').text(),
	                            qty: $self.find('.quantity-select').val(),
	                            options: getOptions($self)
	                        });
	                    }
	                });
	                pidsObj = JSON.stringify(setPids);
	            }

	            pid = base.getPidValue($self);

	            var $productContainer = $self.closest('.product-detail');
	            if (!$productContainer.length) {
	                $productContainer = $self.closest('.quick-view-dialog').find('.product-detail');
	            }

	            addToCartUrl = getAddToCartUrl();

	            var form = {
	                pid: pid,
	                pidsObj: pidsObj,
	                childProducts: getChildProducts(),
	                quantity: getQuantitySelected($self) || 1
	            };

	            if ($('body').hasClass('checkOutPage')) {
	                form.checkOutPage = true;
	            }

	            if (!$('.bundle-item').length) {
	                form.options = getOptions($productContainer);
	            }

	            //IN-AR TRY ON
	            var tryOnButton = $('.js-tryOn-button'),
	                dataEvent = {};

	            if (tryOnButton && tryOnButton.length > 0) {
	                var tryOnDesktopClick = 'false',
	                    tryOnMobileRedirect = 'false';
	                //If the device is Mobile/Tablet we will have the info of the Try-on usage in a specific div
	                if (detectDevice.detectMobile()) {
	                    tryOnMobileRedirect = $('.try-on-redirected').attr('data-used-try-on');
	                }
	                //If the device is Desktop we will have the info of the Try-on button clicked in the button itself
	                else {
	                        if (tryOnButton.length > 0) {
	                            tryOnDesktopClick = $('.js-tryOn-button').attr('data-ga-cliked');
	                        }
	                    }

	                form.tryOnDesktopClick = tryOnDesktopClick;
	                form.tryOnMobileRedirect = tryOnMobileRedirect;
	            }

	            // Analytics data
	            $('body').trigger('analytics:addToCartSubmitting', form);

	            $(this).trigger('updateAddToCartFormData', form);
	            if (addToCartUrl) {
	                $.ajax({
	                    url: addToCartUrl,
	                    method: 'POST',
	                    data: form,
	                    success: function success(data) {
	                        if (data.limitMessage || data.unavailableItemAdded) {
	                            $('#cartLimit-modal-body').text(data.limitMessage || '');
	                            $('#cartLimit-modal').modal('show');
	                            $.spinner().stop();
	                        } else {
	                            //normal behavior
	                            handlePostCartAdd(data);
	                            //update the minicart price total
	                            $('.js-header').removeClass('cc-header__tag__scrollDown');
	                            if ($('.minicartIconPrice').length > 0) {
	                                $('.minicartIconPrice').html(data.cart.totals.subTotal);
	                            }
	                            $('#analytics-cartInfo').data('value', data.cart && data.cart.totals && data.cart.totals.grandTotalDecimal);
	                            $('#analytics-cartInfo').data('couponsName', data.cart && data.cart.couponNamesString);
	                            $('body').trigger('product:afterAddToCart', data);

	                            //analytics event
	                            dataEvent.productID = pid;
	                            if (tryOnButton && tryOnButton.length > 0) {
	                                dataEvent.tryOnDesktopClick = tryOnDesktopClick;
	                                dataEvent.tryOnMobileRedirect = tryOnMobileRedirect;
	                            }

	                            $('body').trigger('analytics:addToCart', dataEvent);

	                            $.spinner().stop();
	                            base.miniCartReportingUrl(data.reportingURL);
	                            $('.cc-minicart-overlay').addClass('opened-by-add-to-bag');
	                            var minicartTimeout = parseInt($('#minicartIcon').data('timeout'));

	                            // if (minicartTimeout > 0) {
	                            //     setTimeout(function() {
	                            //         if ($('.cc-minicart-overlay').hasClass('opened-by-add-to-bag')) {
	                            //             //close minicart only of is opened automatically from pdp or plp or wishlist
	                            //             $('#closeMiniCartButton').click();
	                            //             $('.cc-minicart-overlay').removeClass('opened-by-add-to-bag');
	                            //         }
	                            //     }, minicartTimeout);
	                            // }

	                            var isCartPage = $('.cc-cart-container');

	                            showMiniCart(data.reportingURL).then(function () {
	                                if (isCartPage.length > 0) {
	                                    window.location.reload();
	                                }
	                            });
	                        }
	                    },
	                    error: function error() {
	                        $.spinner().stop();
	                    }
	                });
	            }
	        });
	    }
	};

/***/ }),

/***/ 155:
/***/ (function(module, exports) {

	"use strict";

	/**
	 * A function that detects user's device.
	 * @returns {Boolean} Returns `true` if user's device is mobile/tablet.
	 */
	function detectMobile() {
	    var toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];

	    return toMatch.some(function (toMatchItem) {
	        return navigator.userAgent.match(toMatchItem);
	    });
	}

	module.exports = {
	    detectMobile: detectMobile
	};

/***/ })

/******/ });